import React, {Component} from "react";
import './index.css';
import Prompt from "../../../Components/Prompt";
import PropTypes from 'prop-types';
import moment from "jalali-moment";
import Product from '../../../Server/Product';
import InputButton from '../../../Components/Control/InputButton';
import MyComponent from '../../../Components/MyComponent';
import Perms from '../../../Perms';
import Resource from '../../../Resource';

class PageTrackProduct extends MyComponent {
    constructor (props) {
        super(props);

        if (!Perms().DASHBOARD.TRACK_PRODUCT)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            productData: [],
            fields: {}
        };

        this.ref = {
            prompt: React.createRef()
        };
    }

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        return this.state.productData || nextState.productData;
    }

    render () {
        const {state} = this;

        return <React.Fragment>
            <div className={'PageTrackProduct-product pad-4'}>
                <InputButton buttonTitle={'بررسی'} label={'شماره فرآورده'} align={'center'} direction={'ltr'} placeholder={'........................................................................'} onEnter={this.getProductTrackInfo.bind(this)} onButtonClick={this.getProductTrackInfo.bind(this)} onChange={this.setField.bind(this, 'productNumber')}/>
            </div>
            {state.productData?.length ? <div className={'timeline'}>
                <div className={'timeline-start'} style={{'--color2': this.colors(0)}}/>
                {state.productData.map((item, index) => <Timeline key={index} title={item.title} date={item.date} color1={item.color1} color2={item.color2} data={item.data}/>)}
                {/*<div className={'dis-f'}>*/}
                {/*    <dis className={'pad-4'}>*/}
                {/*        <Button theme={'yellow'}>ویرایش</Button>*/}
                {/*    </dis>*/}
                {/*    <dis className={'pad-4'}>*/}
                {/*        <Button theme={'red'}>حذف</Button>*/}
                {/*    </dis>*/}
                {/*    <dis className={'pad-4'}>*/}
                {/*        <Button theme={'red'}>امحا</Button>*/}
                {/*    </dis>*/}
                {/*    <dis className={'pad-4'}>*/}
                {/*        <Button theme={'yellow'}>عودت</Button>*/}
                {/*    </dis>*/}
                {/*</div>*/}
                {/*</Timeline>)}*/}
                <div className={'timeline-end'} style={{'--color1': this.colors(state.productData?.length || 0)}}/>
            </div> : null}
            <Prompt ref={this.ref.prompt}/>
        </React.Fragment>;
    }

    fieldWillUpdate (keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'productNumber':
                this.setState({productData: []});
                break;
            default:
        }
    }

    getProductTrackInfo (productNumber) {
        this.setState({productData: this.loading});

        Product.track({productNumber})
            .then(data => {
                const productData = data.map((item, index) => {
                    const data = [];
                    if (item.userStr)
                        data.push({key: 'نام کاربر', value: item.userStr});
                    if (item.receiverFullName)
                        data.push({key: 'تحویل گیرنده', value: item.receiverFullName});
                    if (item.createDateTime)
                        data.push({key: 'تاریخ', value: moment(item.createDateTime).format('jYYYY/jMM/jDD HH:mm')});
                    if (item.productBloodGroupStr)
                        data.push({key: 'گروه خونی فرآورده', value: item.productBloodGroupStr});
                    if (item.productTypeStr)
                        data.push({key: 'نوع فرآورده', value: item.productTypeStr});
                    if (item.patientFileCodeStr)
                        data.push({key: 'شماره پرونده', value: item.patientFileCodeStr});
                    if (item.patientNationalCode)
                        data.push({key: 'کد‌ملی بیمار', value: item.patientNationalCode});
                    if (item.patientFullName)
                        data.push({key: 'نام کامل بیمار', value: item.patientFullName});

                    return {
                        date: moment(item.createDateTime),
                        title: item.operationTypeStr || 'عملیات',
                        color1: this.colors(index),
                        color2: this.colors(index + 1),
                        data
                    };
                });

                this.setState({
                    data,
                    productData
                });
            })
            .catch(message => {
                this.setState({productData: []});
            });
    }

    colors (index) {
        const colors = ['#e76f51', '#f4a261', '#e9c46a', '#2a9d8f', '#264653', '#3d5a80', '#98c1d9'];

        return colors[index % 7];
    }

    loading = [{
        title: '..........',
        color1: this.colors(0),
        color2: this.colors(1),
        data: [{key: '......... ', value: '..............................'}, {key: '......... ', value: '..............................'}]
    }, {
        title: '.........................',
        color1: this.colors(1),
        color2: this.colors(2),
        data: [{key: '......... ', value: '..............................'}, {key: '......... ', value: '..............................'}, {key: '......... ', value: '..............................'}, {key: '......... ', value: '..............................'}]
    }, {
        title: '.................',
        color1: this.colors(2),
        color2: this.colors(3),
        data: [{key: '......... ', value: '..............................'}, {key: '......... ', value: '..............................'}, {key: '......... ', value: '..............................'}]
    }];
}

class Timeline extends Component {
    constructor (props) {
        super(props);

        this.state = {};
    }

    static defaultProps = {
        date: null,
        title: null,
        color1: null,
        color2: null
    };

    static propTypes = {
        date: PropTypes.object,
        title: PropTypes.string,
        color1: PropTypes.string.isRequired,
        color2: PropTypes.string.isRequired
    };

    render () {
        const {props} = this;

        return <div className={`Timeline-item`} style={{'--color1': props.color1, '--color2': props.color2}}>
            <div className={'Timeline-pin'}><span>{props.date?.format('jDD') || '...'}</span></div>
            <div className="Timeline-block">
                <div className="Timeline-head">
                    <span className={'time'}>{props.date?.format('jMMMM jYY - ساعت HH:mm') || '..............................'}</span>
                    <span className={'title'}>{props.title}</span>
                </div>
                {props.data && <table className={'Timeline-table'}>
                    <tbody>
                    {props.data.map((item, index) => <tr key={index}>
                        <th>{item.key}:</th>
                        <td>{item.value}</td>
                    </tr>)}
                    </tbody>
                </table>}
                {props.children}
            </div>
        </div>;
    }
}

export default PageTrackProduct;